import React, { useState, useEffect } from 'react'
import { Row, Form, Button, Col } from 'react-bootstrap';
import {  useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { toast } from 'react-toastify';
import { useGetTeacherAnswerQuery } from '../../slices/teachers/teacherQuestionsApiSlice';
import TeacherHeader from '../../components/TeacherHeader';
import TeacherNavbar from '../../components/TeacherNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';

const TeacherAnswerType = () => {

    const navigate = useNavigate();

    const { id } = useParams();

    const { data, isLoading, error } = useGetTeacherAnswerQuery(id);

    const { teacherInfo } = useSelector((state) => state.authTeacher);

    useEffect(() => {
        if(!teacherInfo) {
            navigate('/teacherlogin')
        }
    }, [navigate, teacherInfo])

  return (
    <div>
        <TeacherNavbar />
        <div className="main-content" id="panel">
            <TeacherHeader /><br /><br /><br /><br />        
            <div className="container-fluid mt--6">
                <div className="row"><br />
                    <h4 className="centerTitle tittleColor4 ">
                        <span className='tittleColor4'>Upload a video or record your anwser</span>
                        </h4><br /><br />
                    <div className="col-lg-4 ">   
                        <LinkContainer to={`/teacherupload/${id}`} >
                            <div className="card bg-gradient-warning">
                                <div className="card-body mouseP">
                                    <div className="row">                        
                                        <div className="col"><br />
                                        <span className="h2 font-weight-bold mb-0 text-white">Upload new video </span>
                                        </div>
                                        <div className="col-auto">
                                        <div className="icon icon-shape bg-white text-dark rounded-circle shadow">
                                            <i className="ni ni-atom"></i>
                                        </div>
                                        </div>
                                    </div>
                                    <p className="mt-3 mb-0 text-sm"><br />
                                        <span className="text-nowrap text-light">Upload a new video from your computer</span>
                                    </p>
                                </div>
                            </div>
                        </LinkContainer>  
                    </div>
                    <div className="col-lg-4 ">   
                        <LinkContainer to={`/teacherscreen/${id}`} >
                            <div className="card bg-gradient-info">
                                <div className="card-body mouseP">
                                    <div className="row">
                                        <div className="col"><br />
                                        <span className="h2 font-weight-bold mb-0 text-white ">Record PC screen</span>
                                        </div>
                                        <div className="col-auto">
                                        <div className="icon icon-shape bg-white text-dark rounded-circle shadow">
                                            <i className="ni ni-active-40"></i>
                                        </div>
                                        </div>
                                    </div>
                                    <p className="mt-3 mb-0 text-sm"><br />
                                        <span className="text-white mr-2"><i className="fa fa-arrow-up"></i> </span>
                                        <span className="text-nowrap text-light">Record your screen to anwers a question</span>
                                    </p>
                                </div>
                            </div>
                        </LinkContainer>  
                    </div>
                    <div className="col-lg-4">   
                        <LinkContainer to={`/teachercamera/${id}`} >
                            <div className="card bg-gradient-danger">
                                <div className="card-body mouseP">
                                <div className="row">
                                    <div className="col"><br />                            
                                    <span className="h2 font-weight-bold mb-0 text-white">Record Camera</span>
                                    </div>
                                    <div className="col-auto">
                                    <div className="icon icon-shape bg-white text-dark rounded-circle shadow">
                                        <i className="ni ni-spaceship"></i>
                                    </div>
                                    </div>
                                </div>
                                <p className="mt-3 mb-0 text-sm"><br />
                                    <span className="text-white mr-2"><i className="fa fa-arrow-up"></i> </span>
                                    <span className="text-nowrap text-light">Record your camera to anwers a question</span>
                                </p>
                                </div>
                            </div>
                        </LinkContainer>  
                    </div>   
                    <div className="col-lg-4">   
                        <LinkContainer to={`/teacherreuseanswer/${data?.subject}/${id}`} >
                            <div className="card bg-gradient-primary">
                                <div className="card-body mouseP">
                                <div className="row">
                                    <div className="col"><br />                            
                                    <span className="h2 font-weight-bold mb-0 text-white">Re-Use Anwser from questions </span>
                                    </div>
                                    <div className="col-auto">
                                    <div className="icon icon-shape bg-white text-dark rounded-circle shadow">
                                        <i className="ni ni-spaceship"></i>
                                    </div>
                                    </div>
                                </div>
                                <p className="mt-3 mb-0 text-sm"><br />
                                    <span className="text-white mr-2"><i className="fa fa-arrow-up"></i> </span>
                                    <span className="text-nowrap text-light">Use an anwser from another question</span>
                                </p>
                                </div>
                            </div>
                        </LinkContainer>  
                    </div>
                </div>              
            </div>
        </div>
      
    </div>
  )
}

export default TeacherAnswerType
